import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  LoadAdhocListLineColumns,
  LoadAdhocListLineCountSuccess,
  LoadAdhocListLineSuccess,
  LoadTestAdhocListLineColumns,
  LoadTestAdhocListLineCountSuccess,
  LoadTestAdhocListLineSuccess,
  PagingChanged,
  TestPagingChanged,
} from '../actions/adhoc-list-line.actions';

export interface AdhocListLineState extends EntityState<any> {
  columns: { [label: string]: string };
  totalResults: number;
  itemsNumber: number;
  paginator: {
    previousPageIndex: number;
    pageIndex: number;
    pageSize: number;
    length: number;
  };
}

export const adhocListLineAdapter = createEntityAdapter<any>();

const initialState: AdhocListLineState = adhocListLineAdapter.getInitialState({
  columns: {},
  totalResults: 0,
  itemsNumber: 10,
  paginator: {
    previousPageIndex: 0,
    pageIndex: 0,
    pageSize: 0,
    length: 0,
  },
});

export const AdhocListLineReducer = createReducer(
  initialState,
  on(LoadAdhocListLineColumns, (state, { columns }) => ({
    ...state,
    columns,
  })),
  on(LoadTestAdhocListLineColumns, (state, { columns }) => ({
    ...state,
    columns,
  })),
  on(LoadAdhocListLineCountSuccess, (state, { count }) => ({
    ...state,
    totalResults: count,
  })),
  on(LoadTestAdhocListLineCountSuccess, (state, { count }) => ({
    ...state,
    totalResults: count,
  })),
  on(PagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(TestPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(LoadAdhocListLineSuccess, (state, { data }) => {
    const adhocListLineData = data.map((item: any) => ({
      id: item.id,
      firstName: item.firstName,
      lastName: item.lastName,
      loyaltyCard: item.loyaltyCard,
      points: item.points,
      schema: item.schemaId,
      email: item.email,
      mobile: item.mobile,
      smsOptOut: item.smsOptOut,
      emailOptOut: item.emailOptOut,
    }));
    return adhocListLineAdapter.setAll(adhocListLineData, { ...state });
  }),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
  on(LoadTestAdhocListLineSuccess, (state, { data }) => {
    const adhocListLineData = data.map((item: any) => ({
      id: item.id,
      firstName: item.firstName,
      lastName: item.lastName,
      loyaltyCard: item.loyaltyCard,
      points: item.points,
      schema: item.schemaId,
      email: item.email,
      mobile: item.mobile,
      smsOptOut: item.smsOptOut,
      emailOptOut: item.emailOptOut,
    }));
    return adhocListLineAdapter.setAll(adhocListLineData, { ...state });
  }),
);
